import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { SettingsGroup } from '../SettingsGroup';

import FormFieldSettings from './FormFieldSettings/FormFieldSettings';
import RootCausesSettings from './RootCausesSettings/RootCausesSettings';

const FollowUpModuleSettings: FC = () => {
  const { t } = useTranslation('survey');
  return (
    <SettingsGroup headline={t('settings.followUpModule.headline')}>
      <RootCausesSettings />
      <FormFieldSettings />
    </SettingsGroup>
  );
};

export default FollowUpModuleSettings;
